import Vue from "vue";
import VueRouter, { RouteConfig } from "vue-router";
import SupplierPage from "@/features/Supplier/SupplierPage.vue";
import LoginPage from "@/features/Authentication/LoginPage.vue";
import AccessDeniedPage from "@/features/Authentication/AccessDeniedPage.vue";
import { useUserStore } from "@/plugins/pinia";

Vue.use(VueRouter);

const routes: Array<RouteConfig> = [
    // TODO #3738208: Update routing to allow nav to score/scorecard/supplier event/incident details within supplier page

    {
        path: "/supplier/:supplierID?",
        name: "supplier",
        component: SupplierPage,
    },
    {
        path: "/login",
        name: "login",
        component: LoginPage,
    },
    {
        path: "/access-denied",
        name: "access-denied",
        component: AccessDeniedPage,
    },
    {
        path: "*",
        name: "NotFound",
        redirect: "/supplier/",
    },
];

const router = new VueRouter({
    mode: "history",
    base: process.env.BASE_URL,
    routes,
    scrollBehavior() {
        return { x: 0, y: 0 };
    },
});

// If the user is not logged in, they should go to a screen that only indicates they need to log in.
router.beforeEach(async (to, from, next) => {
    const userStore = useUserStore();

    // User is logged in
    if (userStore.loggedIn) {
        // Future: Maybe some auth checks against the route metadata?
        next();
    } else {
        // User is not logged in
        // They are forced to go to the login page.
        // This will trigger the login workflow.
        if (to.name !== "login") {
            Vue.prototype.$sessionService.saveRouteForPostLoginRedirect(window.location.href);
            // Force to login
            next({ name: "login" });
        } else {
            // They are already on the login page...what? go ahead
            next();
        }
    }
});

export default router;
